import React, { useState } from 'react';
import CourseCard from './CourseCard';
import { courses } from './courseData';

const CLASS_GROUPS = [
  { label: "Class 8", filter: "8" },
  { label: "Class 9", filter: "9" },
  { label: "Class 10", filter: "10" },
];

const ChevronIcon = ({ expanded }) => (
  <svg
    height="14"
    width="14"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
    style={{
      transition: 'transform 0.3s',
      transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
    }}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

const GradCapIcon = () => (
  <svg height="14" width="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
  </svg>
);

const FACULTY = [
  { name: "Rahul Kumar", credentials: "B.Tech IIT Goa", imageSrc: "/assets/Rahul.jpeg" },
  { name: "Amit Prakash", credentials: "B.Tech IIT BHU", imageSrc: "/assets/Amit.jpeg" },
  { name: "Vishal Singh", credentials: "B.Tech IIT Delhi", imageSrc: "/assets/Vishal.jpeg" },
];

const CourseList = () => {
  const [expandedClasses, setExpandedClasses] = useState({});

  const toggleClass = (classLabel) => {
    setExpandedClasses((prev) => ({
      ...prev,
      [classLabel]: !prev[classLabel]
    }));
  };

  const getCoursesForClass = (filter) => {
    const classCourses = courses.filter((course) => {
      // Match class number from the title suffix like MI8, SI8, MSI8, MI9, etc.
      if (filter === "10") return course.title.includes("10");
      if (filter === "9") return course.title.includes("9") && !course.title.includes("10");
      if (filter === "8") return course.title.includes("8") && !course.title.includes("10");
      return false;
    });

    return classCourses.sort((a, b) => {
      if (a.courseId.includes("MSI") && !b.courseId.includes("MSI")) return -1;
      if (!a.courseId.includes("MSI") && b.courseId.includes("MSI")) return 1;
      if (a.courseId.includes("MI") && b.courseId.includes("SI")) return -1;
      if (a.courseId.includes("SI") && b.courseId.includes("MI")) return 1;
      return 0;
    });
  };

  return (
    <div style={{ width: '100%', maxWidth: '1280px', margin: '0 auto', padding: '1.5rem 5vw 4rem', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      {/* Promo tag above the card */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: 0 }}>
        <div className="promo-tag-responsive" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.375rem',
          borderRadius: '0.5rem 0.5rem 0 0',
          backgroundImage: 'linear-gradient(to right, #ef4444, #e11d48)',
          padding: '0.375rem 1rem',
          fontSize: '12px',
          fontWeight: '700',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: '#ffffff',
          boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
        }}>
          <svg className="promo-tag-icon" style={{ height: '1rem', width: '1rem', color: '#fde047' }} fill="currentColor" viewBox="0 0 24 24">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
          </svg>
          Enroll Now &amp; Get a Free Problem Solving Course for 2 Months!
          <span style={{ marginLeft: '0.25rem', textDecoration: 'line-through', color: 'rgba(255,255,255,0.6)' }}>₹4,000</span>
          <span className="promo-tag-free" style={{ borderRadius: '0.25rem', backgroundColor: '#ffffff', padding: '0.125rem 0.375rem', fontSize: '10px', fontWeight: '900', textTransform: 'uppercase', color: '#dc2626' }}>FREE</span>
        </div>
      </div>
      <style>{`
        @media (max-width: 639px) {
          .promo-tag-responsive { font-size: 8px !important; padding: 0.25rem 0.5rem !important; }
          .promo-tag-icon { height: 0.75rem !important; width: 0.75rem !important; }
          .promo-tag-free { font-size: 7px !important; }
        }
        @media (min-width: 1024px) {
          .promo-tag-responsive { font-size: 14px !important; padding: 0.5rem 1.25rem !important; }
          .promo-tag-icon { height: 1.125rem !important; width: 1.125rem !important; }
          .promo-tag-free { font-size: 11px !important; }
        }
      `}</style>

      {/* Banner replacement */}
      <div style={{
        backgroundColor: '#FFF8DD',
        borderRadius: '1rem',
        borderTopRightRadius: 0,
        padding: '1rem 1.5rem',
        marginBottom: '2rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        position: 'relative'
      }}>
        {/* Top Row: Pill */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{
            backgroundColor: '#FFFFFF',
            color: '#0E1C48',
            fontSize: '0.6rem',
            fontWeight: '900',
            padding: '0.25rem 0.6rem',
            borderRadius: '9999px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F5C518" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="2" y1="12" x2="22" y2="12"></line>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
            </svg>
            After School Evening Online Academic Excellence Program
          </div>
        </div>

        {/* Main Content Area: Left Title & Right Icons */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1.5rem', marginTop: '0.25rem' }}>

          {/* Left Section */}
          <div style={{ flex: '1 1 250px', minWidth: 0 }}>
            <h1 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#0E1C48', margin: '0 0 0.5rem 0', lineHeight: '1.2' }}>
              Maths and Science by IITians
            </h1>

            <style>{`
              @keyframes pulseScale {
                0%, 100% { transform: scale(1); }
                50% { transform: scale(1.05); }
              }
              .course-strip {
                display: flex;
                width: 100%;
                flex-direction: column;
                align-items: stretch;
                gap: 0.5rem;
                padding: 0.5rem 0.75rem;
                font-size: 11px;
              }
              .course-strip-inner-right {
                display: flex;
                width: 100%;
                align-items: center;
                justify-content: space-between;
                gap: 0.5rem;
              }
              @media (min-width: 640px) {
                .course-strip {
                  flex-direction: row;
                  align-items: center;
                  justify-content: space-between;
                  gap: 0.75rem;
                  font-size: 12px;
                }
                .course-strip-inner-right {
                  width: auto;
                  justify-content: flex-end;
                  gap: 0.75rem;
                }
              }
              @media (min-width: 1024px) {
                .course-strip { font-size: 14px; }
                .free-course-banner { font-size: 11px !important; }
                .course-original-price { font-size: 12px !important; }
                .course-off-badge { font-size: 10px !important; }
                .course-off-badge svg { width: 12px !important; height: 12px !important; }
              }
            `}</style>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem' }}>
              <div style={{ animation: 'pulseScale 2s ease-in-out infinite', display: 'inline-block', backgroundColor: '#E10000', color: '#FFF', fontSize: '0.7rem', fontWeight: '800', padding: '0.25rem 0.75rem', borderRadius: '9999px', textTransform: 'uppercase', boxShadow: '0 10px 15px -3px rgba(225, 0, 0, 0.3)' }}>
                FAST TRACK COURSE
              </div>
              <div style={{ display: 'inline-block', borderRadius: '9999px', border: '1px solid rgba(14, 28, 72, 0.15)', backgroundColor: '#0E1C48', padding: '0.25rem 0.75rem', fontSize: '0.7rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#ffffff', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
                CBSE | JEE | NEET - FOUNDATION
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0.5rem', marginTop: '0.5rem' }}>
              <a
                href="https://maps.google.com/?q=MIET+Public+School+Mawana+Road+Meerut"
                target="_blank"
                rel="noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  textAlign: 'left',
                  gap: '0.5rem',
                  fontSize: '0.80rem',
                  fontWeight: '500',
                  color: '#64748b',
                  textDecoration: 'underline',
                  textDecorationColor: 'rgba(245, 197, 24, 0.7)',
                  textDecorationThickness: '2px',
                  textUnderlineOffset: '4px',
                  transition: 'color 0.2s',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.target.style.color = '#0E1C48'}
                onMouseLeave={(e) => e.target.style.color = '#64748b'}
              >
                <svg style={{ flexShrink: 0, marginTop: '0.1rem', width: '1rem', height: '1rem', color: 'rgba(14, 28, 72, 0.7)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Offline at MIET Public School, Mawana Road, Meerut</span>
              </a>
              <span style={{ display: 'flex', alignItems: 'flex-start', textAlign: 'left', gap: '0.375rem', fontSize: '0.80rem', fontWeight: '500', color: '#64748b' }}>
                <svg style={{ flexShrink: 0, marginTop: '0.1rem', width: '1rem', height: '1rem', color: 'rgba(14, 28, 72, 0.7)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>2 way Live Interactive Online Classes</span>
              </span>
            </div>
          </div>

          {/* Right Section (Icons) */}
          <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'center' }}>
            {/* Icon 1 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ width: '2rem', height: '2rem', borderRadius: '50%', backgroundColor: '#0E1C48', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#FFF' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                </svg>
              </div>
              <div style={{ fontSize: '0.6rem', fontWeight: '800', color: '#0E1C48', lineHeight: '1.2' }}>
                100%<br />IITIAN FACULTIES
              </div>
            </div>

            {/* vertical divider */}
            <div style={{ width: '1px', height: '2rem', backgroundColor: '#d1d5db' }}></div>

            {/* Icon 2 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ width: '2rem', height: '2rem', borderRadius: '50%', backgroundColor: '#0E1C48', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#FFF' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
                </svg>
              </div>
              <div style={{ fontSize: '0.6rem', fontWeight: '800', color: '#0E1C48', lineHeight: '1.2' }}>
                WEEKLY ASSESSMENT AND<br />LECTURE WORKSHEETS
              </div>
            </div>

            {/* vertical divider */}
            <div style={{ width: '1px', height: '2rem', backgroundColor: '#d1d5db' }}></div>

            {/* Icon 3 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ width: '2rem', height: '2rem', borderRadius: '50%', backgroundColor: '#0E1C48', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#FFF' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72l5 2.73 5-2.73v3.72z" />
                </svg>
              </div>
              <div style={{ fontSize: '0.6rem', fontWeight: '800', color: '#0E1C48', lineHeight: '1.2' }}>
                1 ON 1 MENTORSHIP<br />BY IITIANS
              </div>
            </div>

            {/* vertical divider */}
            <div style={{ width: '1px', height: '2rem', backgroundColor: '#d1d5db' }}></div>

            {/* Icon 4 */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ width: '2rem', height: '2rem', borderRadius: '50%', backgroundColor: '#0E1C48', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#FFF' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                </svg>
              </div>
              <div style={{ fontSize: '0.6rem', fontWeight: '800', color: '#0E1C48', lineHeight: '1.2' }}>
                1 ON 1 DOUBT SESSIONS<br />BY IITIANS
              </div>
            </div>

          </div>
        </div>
      </div>

      <div style={{ marginBottom: '2.5rem', position: 'relative', zIndex: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.25rem' }}>
          <div style={{ display: 'flex', height: '2rem', width: '2rem', alignItems: 'center', justifyContent: 'center', borderRadius: '9999px', backgroundColor: '#0E1C48', color: 'white', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
            <svg height="16" width="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
          </div>
          <h3 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#0E1C48', margin: 0 }}>Founder and Faculty Details</h3>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          {/* Founder Card */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                gap: '0.75rem',
                overflow: 'hidden',
                borderRadius: '1rem',
                border: '1px solid rgba(14, 28, 72, 0.1)',
                backgroundColor: 'white',
                padding: '1rem 1.25rem',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s',
                width: '100%',
                maxWidth: '540px'
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(14, 28, 72, 0.1)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 1px 2px 0 rgba(0, 0, 0, 0.05)'; }}
            >
              <a
                href="https://www.linkedin.com/in/alokbansaliitdelhi/"
                target="_blank"
                rel="noreferrer"
                style={{
                  position: 'absolute',
                  right: '1rem',
                  top: '1rem',
                  display: 'flex',
                  height: '2rem',
                  width: '2rem',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '9999px',
                  backgroundColor: 'rgba(14, 28, 72, 0.05)',
                  color: 'rgba(14, 28, 72, 0.6)',
                  transition: 'background-color 0.2s, color 0.2s',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(14, 28, 72, 0.1)'; e.currentTarget.style.color = 'rgba(14, 28, 72, 1)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'rgba(14, 28, 72, 0.05)'; e.currentTarget.style.color = 'rgba(14, 28, 72, 0.6)'; }}
              >
                <svg style={{ height: '1rem', width: '1rem', fill: 'currentColor' }} viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452z" />
                </svg>
              </a>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                <div style={{ position: 'relative', height: '4rem', width: '4rem', flexShrink: 0, overflow: 'hidden', borderRadius: '9999px', border: '2px solid #E8EDFF', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
                  <img src="/assets/Founder.jpg" alt="Mr. Alok Bansal" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <span style={{ fontSize: '1.125rem', fontWeight: '700', color: '#0E1C48' }}>Mr. Alok Bansal</span>
                  <span style={{ fontSize: '0.875rem', fontWeight: '500', color: '#64748b' }}>Founder | B.Tech IIT Delhi</span>
                </div>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '0.5rem', paddingTop: '0.25rem' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', borderRadius: '0.375rem', backgroundColor: '#F4F7FF', padding: '0.25rem 0.625rem', fontSize: '11px', fontWeight: '700', color: '#0E1C48', border: '1px solid rgba(14, 28, 72, 0.1)' }}>
                  20+ Years Experience
                </span>
                <span style={{ display: 'inline-flex', alignItems: 'center', borderRadius: '0.375rem', backgroundColor: '#F4F7FF', padding: '0.25rem 0.625rem', fontSize: '11px', fontWeight: '700', color: '#0E1C48', border: '1px solid rgba(14, 28, 72, 0.1)' }}>
                  2000+ in IIT
                </span>
                <span style={{ display: 'inline-flex', alignItems: 'center', borderRadius: '0.375rem', backgroundColor: '#F4F7FF', padding: '0.25rem 0.625rem', fontSize: '11px', fontWeight: '700', color: '#0E1C48', border: '1px solid rgba(14, 28, 72, 0.1)' }}>
                  5000+ in NIT, BITS, NSIT
                </span>
                <span style={{ display: 'inline-flex', alignItems: 'center', borderRadius: '0.375rem', backgroundColor: '#F4F7FF', padding: '0.25rem 0.625rem', fontSize: '11px', fontWeight: '700', color: '#0E1C48', border: '1px solid rgba(14, 28, 72, 0.1)' }}>
                  AIR 1 in 2021
                </span>
              </div>
            </div>
          </div>

          {/* Faculty Cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))', gap: '1rem' }}>
            {FACULTY.map((member, idx) => (
              <div key={idx} style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: '0.875rem', overflow: 'hidden', borderRadius: '1rem', border: '1px solid rgba(14, 28, 72, 0.1)', backgroundColor: 'white', padding: '0.625rem 1rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', transition: 'all 0.3s' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(14, 28, 72, 0.1)'; }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 1px 2px 0 rgba(0, 0, 0, 0.05)'; }}>
                <div style={{ position: 'relative', height: '3.5rem', width: '3.5rem', flexShrink: 0, overflow: 'hidden', borderRadius: '9999px', border: '2px solid #E8EDFF', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
                  <img src={member.imageSrc || "/assets/User.png"} alt={member.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '11px', fontWeight: '500', color: '#64748b' }}>{member.name}</span>
                  <span style={{ fontSize: '13px', fontWeight: '700', color: '#0E1C48' }}>{member.credentials}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '-0.25rem' }}>
          <button
            type="button"
            onClick={() => {
              const allExpanded = CLASS_GROUPS.every(group => expandedClasses[group.label]);
              if (allExpanded) {
                setExpandedClasses({});
              } else {
                const newExpanded = {};
                CLASS_GROUPS.forEach(group => { newExpanded[group.label] = true; });
                setExpandedClasses(newExpanded);
              }
            }}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.375rem',
              fontSize: '10px',
              fontWeight: '700',
              color: '#0E1C48',
              backgroundColor: '#F8FAFC',
              border: '1px solid rgba(14, 28, 72, 0.1)',
              borderRadius: '9999px',
              padding: '0.375rem 0.875rem',
              cursor: 'pointer',
              transition: 'all 0.2s',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#0E1C48';
              e.currentTarget.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#F8FAFC';
              e.currentTarget.style.color = '#0E1C48';
            }}
          >
            {CLASS_GROUPS.every(group => expandedClasses[group.label]) ? "Collapse All" : "Expand All"}
          </button>
        </div>
        {CLASS_GROUPS.map((group) => {
          const classCourses = getCoursesForClass(group.filter);
          const courseCount = classCourses.length;
          const expanded = !!expandedClasses[group.label];

          return (
            <div
              key={group.label}
              style={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: '1.5rem',
                border: '1px solid rgba(14, 28, 72, 0.1)',
                backgroundColor: '#ffffff',
                boxShadow: '0 10px 28px rgba(14, 28, 72, 0.08)',
                transition: 'all 0.3s',
              }}
            >
              {/* Decorative blurs */}
              <div style={{
                position: 'absolute', right: '-4rem', top: '-4rem',
                height: '10rem', width: '10rem', borderRadius: '50%',
                backgroundColor: 'rgba(232, 237, 255, 0.7)', filter: 'blur(40px)',
                pointerEvents: 'none',
              }} />
              <div style={{
                position: 'absolute', left: '-4rem', bottom: '-4rem',
                height: '8rem', width: '8rem', borderRadius: '50%',
                backgroundColor: 'rgba(254, 243, 199, 0.5)', filter: 'blur(40px)',
                pointerEvents: 'none',
              }} />

              {/* Header button */}
              <button
                type="button"
                onClick={() => toggleClass(group.label)}
                style={{
                  position: 'relative',
                  width: '100%',
                  padding: '1.25rem 1.75rem',
                  textAlign: 'left',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', gap: '1rem' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0.5rem', flex: '1 1 auto', textAlign: 'left' }}>
                      <span style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.375rem',
                        borderRadius: '9999px',
                        border: '1px solid rgba(14, 28, 72, 0.1)',
                        backgroundColor: '#F8FAFC',
                        padding: '0.25rem 0.75rem',
                        fontSize: '10px',
                        fontWeight: '900',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        color: '#0E1C48',
                      }}>
                        <span style={{ color: '#F5C518' }}><GradCapIcon /></span>
                        {courseCount} {courseCount === 1 ? 'Course' : 'Courses'} Available
                      </span>
                      <p style={{
                        fontSize: '1.125rem',
                        fontWeight: '700',
                        color: '#0E1C48',
                        margin: '0',
                      }}>
                        Maths and Science by IITians{' '}
                        <span style={{
                          color: group.label === "Class 8" ? "#2563eb" :
                            group.label === "Class 9" ? "#059669" :
                              group.label === "Class 10" ? "#9333ea" :
                                "#0E1C48"
                        }}>
                          {group.label}
                        </span>{' '}
                        Courses
                      </p>
                    </div>

                    <span style={{
                      display: 'inline-flex',
                      flexShrink: 0,
                      alignItems: 'center',
                      gap: '0.375rem',
                      borderRadius: '9999px',
                      border: '1px solid rgba(14, 28, 72, 0.1)',
                      backgroundColor: '#0E1C48',
                      padding: '0.375rem 0.75rem',
                      fontSize: '10px',
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                      color: '#ffffff',
                      boxShadow: '0 4px 6px -1px rgba(14, 28, 72, 0.15), 0 2px 4px -2px rgba(14, 28, 72, 0.15)',
                    }}>
                      {expanded ? 'Collapse' : 'Expand'}
                      <ChevronIcon expanded={expanded} />
                    </span>
                  </div>

                  {!expanded && (
                    <div style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'stretch', gap: '0.5rem', marginTop: '1rem' }}>
                      {classCourses.map((c, ci) => {
                        const hasBadge = c.courseId.includes("MSI");
                        const bgColors = ['rgba(254, 243, 199, 0.85)', 'rgba(219, 234, 254, 0.85)', 'rgba(252, 231, 243, 0.85)'];
                        const bgColor = bgColors[ci % bgColors.length];

                        return (
                          <div key={c.courseId} style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                            {hasBadge && (
                              <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                <div className="free-course-banner" style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', borderRadius: '0.5rem 0.5rem 0 0', backgroundImage: 'linear-gradient(to right, #ef4444, #e11d48)', padding: '0.25rem 0.75rem', fontSize: '10px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#ffffff', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
                                  <svg style={{ height: '0.75rem', width: '0.75rem', color: '#fde047' }} fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                                  </svg>
                                  Free Problem Solving Course Worth ₹4000
                                </div>
                              </div>
                            )}
                            <div className="course-strip" style={{ borderRadius: '0.375rem', borderTopRightRadius: hasBadge ? '0' : '0.375rem', border: '1px solid rgba(14, 28, 72, 0.1)', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)', backgroundColor: bgColor, color: '#0E1C48', transition: 'opacity 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'} onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}>
                              <span style={{ fontWeight: '600', lineHeight: '1.25', textAlign: 'left' }}>{c.title}</span>
                              <div className="course-strip-inner-right" style={{ flexShrink: 0 }}>
                                <span style={{ fontWeight: '700' }}>₹{c.discountedPrice.toLocaleString("en-IN")}</span>
                                {c.originalPrice > c.discountedPrice && (
                                  <>
                                    <span className="course-original-price" style={{ fontSize: '10px', fontWeight: '500', color: '#64748b', textDecoration: 'line-through', textDecorationColor: 'rgba(239, 68, 68, 0.5)', textDecorationThickness: '2px' }}>
                                      ₹{c.originalPrice.toLocaleString("en-IN")}
                                    </span>
                                    <span className="course-off-badge" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0.125rem', borderRadius: '9999px', background: 'linear-gradient(to right, #22c55e, #059669)', padding: '0.125rem 0.5rem', fontSize: '9px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '0.05em', color: 'white', boxShadow: '0 1px 2px 0 rgba(34, 197, 94, 0.3)', border: '1px solid rgba(74, 222, 128, 0.5)' }}>
                                      <svg style={{ height: '0.625rem', width: '0.625rem', color: '#dcfce3' }} fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.41l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.36-.36.59-.86.59-1.41s-.23-1.06-.59-1.41zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
                                      </svg>
                                      {Math.round(((c.originalPrice - c.discountedPrice) / c.originalPrice) * 100)}% OFF
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </button>

              {/* Expandable content */}
              <div style={{
                display: 'grid',
                gridTemplateRows: expanded ? '1fr' : '0fr',
                opacity: expanded ? 1 : 0,
                transition: 'grid-template-rows 0.5s ease-in-out, opacity 0.5s ease-in-out',
              }}>
                <div style={{ overflow: 'hidden', borderRadius: '0 0 1.5rem 1.5rem' }}>
                  <div style={{
                    borderTop: '1px solid rgba(14, 28, 72, 0.1)',
                    backgroundColor: '#F8FAFC',
                    padding: '1.5rem',
                  }}>
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))',
                      gap: '1.5rem',
                    }}>
                      {classCourses.map((course, index) => (
                        <CourseCard key={course.id} course={course} index={index} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CourseList;